var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:url(#SVGID_1_)}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 37.5,
    x2: 37.5,
    y1: 60.883,
    y2: 14.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7847e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#f63a8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc754"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5,37.5c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S45.5,33.1,45.5,37.5z M60.9,25.4v24.2 c0,6.2-5.1,11.3-11.3,11.3H25.4c-6.2,0-11.3-5.1-11.3-11.3V25.4c0-6.2,5.1-11.3,11.3-11.3h24.2C55.8,14.1,60.9,19.2,60.9,25.4z M51.3,37.5c0-7.6-6.2-13.8-13.8-13.8s-13.8,6.2-13.8,13.8c0,7.6,6.2,13.8,13.8,13.8S51.3,45.1,51.3,37.5z M56.4,22.6 c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9c0,2.2,1.8,3.9,3.9,3.9C54.6,26.5,56.4,24.7,56.4,22.6z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8afc18b929bd318d2c87ddfce7edce43.svg";
export { ForwardRef as ReactComponent };